module.exports = __webpack_public_path__ + "static/img/top_gf.05a143a5.png";